module.exports = __webpack_public_path__ + "img/fullscreen_exit.62cbb95a.svg";